var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceidIcon = function SvgFaceidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M7.583 2.98h-3.52a1.083 1.083 0 0 0-1.084 1.082v3.521m20.042 0v-3.52a1.084 1.084 0 0 0-1.084-1.084h-3.52m0 20.042h3.52a1.083 1.083 0 0 0 1.084-1.084v-3.52m-20.042 0v3.52a1.083 1.083 0 0 0 1.083 1.084h3.521M8.82 10.867v-1.93m8.362 1.93v-1.93m-5.468 6.433h.644a1.286 1.286 0 0 0 1.287-1.287V8.937m3.215 8.544c-1.048 1.39-2.65 1.748-3.859 1.748s-2.81-.357-3.86-1.748"
  })));
};
export default SvgFaceidIcon;